module.exports = __webpack_public_path__ + "img/prize-icon2.cb627f95.gif";